module.exports = __webpack_public_path__ + "img/logo.b8f9c72a.svg";